import axios from "axios";
import Cookie from "js-cookie";

const CONFIG = {
  insert: {
    mtm: [
      "bank_requests",
      "factors",
      "msgs",
      "tours",
      "tour_reservation_items",
      "users",
      "visits",
      "wallets",
      "wallets_transactions",
    ],
    others: [
      "access_level",
      "attractions",
      "cities",
      "provinces",
      "tour_additional_cost",
      "tour_attraction_links",
      "tour_city_links",
      "tour_daily_schedule",
      "tour_other_field_values",
      "tour_reservation_programs",
      "tour_tags",
      "tour_tags_links",
      "user_acl_links",
      "user_tags",
      "user_tag_links",
      "user_tour_comments",
    ],
  },
  update: {
    uptmtm: ["bank_requests", "factors", "wallets", "wallets_transactions"],
    uptm: ["tours", "tour_reservation_items", "users"],
    others: [
      "access_level",
      "attractions",
      "cities",
      "msgs",
      "provinces",
      "tour_additional_cost",
      "tour_attraction_links",
      "tour_city_links",
      "tour_daily_schedule",
      "tour_other_field_values",
      "tour_reservation_programs",
      "tour_tags",
      "tour_tags_links",
      "user_acl_links",
      "user_tags",
      "user_tag_links",
      "user_tour_comments",
      "visits",
    ],
  },
};

async function connection(
  url,
  data = { fields: "", tbl_name: "", conditions: "" }
) {
  let formData = new FormData();
  formData.append("usertoken", Cookie.get("token"));
  Object.keys(data).forEach((value) => {
    if (data[value] === "") return;
    formData.append(value, data[value]);
  });
  return await axios
    .post(`http://old-sabadib.tatdemo.ir/superadminapi/${url}`, formData)
    .then((res) => {
      // console.log(url, res.data);
      return res.data;
    });
}

async function updateRecord(
  tableName,
  data = { keyvalues: {}, conditions: "" }
) {
  if (
    CONFIG.update.uptm.includes(tableName) &&
    !Object.keys(data.keyvalues).includes("uptm")
  ) {
    let date = new Date();
    data.keyvalues.uptm = Math.floor(date.getTime() / 1000);
  }
  if (
    CONFIG.update.uptmtm.includes(tableName) &&
    !Object.keys(data.keyvalues).includes("uptmtm")
  ) {
    let date = new Date();
    data.keyvalues.uptmtm = Math.floor(date.getTime() / 1000);
  }
  data.keyvalues = Object.keys(data.keyvalues).reduce((total, value, index) => {
    if (index != 0) {
      return (total += "@@" + value + "," + data.keyvalues[value]);
    }
    return (total += value + "," + data.keyvalues[value]);
  }, "");
  return await connection(`Update_${tableName}`, data);
}

async function insertRecord(tableName, data = {}) {
  if (
    CONFIG.insert.mtm.includes(tableName) &&
    !Object.keys(data).includes("mtm")
  ) {
    let date = new Date();
    data.mtm = Math.floor(date.getTime() / 1000);
  }
  return await connection(`Insert_${tableName}`, data);
}

async function findRecord(
  tableName,
  data = { fields: "", tbl_name: "", conditions: "" }
) {
  return await connection(`Find_${tableName}`, data);
}

async function deleteRecord(tableName, conditions) {
  return await connection(`Delete_${tableName}`, { conditions });
}

async function transferMoney(
  fromWalletId,
  toWalletId,
  type,
  price,
  factor_id = 0,
  mtm = 0
) {
  let res = await connection("transfermoney", {
    type: type,
    amount: price,
    from_wallet_id: fromWalletId,
    to_wallet_id: toWalletId,
    factor_id,
    mtm,
  });
  return res.status == 1;
}

async function updateWalletsForTransfer(
  fromWalletId,
  toWalletId,
  price,
  reverse = false
) {
  let keyvalues = {
    from_wallet_id: fromWalletId,
    to_wallet_id: toWalletId,
    amount: price,
  };
  if (reverse) keyvalues.reverse = 1;
  let res = await connection("updatewalletsfortransfer", keyvalues);
  return res.status == 1;
}

function sortArray(data, key) {
  let res = [...data];
  res.sort((a, b) => {
    if (a[key] == b[key]) return 0;
    if (isNaN(a[key]) || a[key] == "") return 1;
    if (isNaN(b[key]) || b[key] == "") return -1;
    return parseInt(b[key]) - parseInt(a[key]);
  });
  return res;
}

export {
  connection,
  updateRecord,
  insertRecord,
  findRecord,
  deleteRecord,
  transferMoney,
  updateWalletsForTransfer,
  sortArray,
  // checkImageExistence,
};
